import { getCookie } from './cookies'

const GA_ID = 'G-5GBXPLZMK3'
let initialized = false
let gtagReady = false
let eventQueue = []

export function initAnalyticsIfAllowed() {
	if (initialized) return
	if (getCookie('cmplz_statistics') === 'allow') {
		initialized = true
		const script = document.createElement('script')
		script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
		script.async = true
		script.onload = () => {
			window.gtag('config', GA_ID, {
				transport_type: 'beacon',
			})
			gtagReady = true
			// Flush any events that fired before gtag was ready
			eventQueue.forEach(({ eventName, params }) => {
				window.gtag('event', eventName, params)
			})
			eventQueue = []
		}
		document.head.appendChild(script)
	}
}

export function trackEvent(eventName, params = {}) {
	if (!initialized) return
	if (!gtagReady) {
		eventQueue.push({ eventName, params })
		return
	}
	window.gtag('event', eventName, params)
}